<template>
  <Head title="Repository Dokumen" />

  <Breadcrumbs
    :breadcrumbs="[
      { name: 'Dashboard', href: route('dashboard') },
      { name: 'Repository Dokumen', href: route('pelaporan.index') },
    ]"
  />
  <div class="max-w-screen-xl px-4 py-4 mx-auto sm:px-6 sm:py-12 lg:px-8">
    <div
      class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between"
    >
      <div>
        <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl">
          Repository Dokumen
        </h1>

        <p class="mt-1.5 text-sm text-gray-500">Dokumen/Pelaporan/SOP</p>
      </div>

      <div class="flex items-center gap-4">
        <button
          v-if="$page.props.can.master_access"
          class="inline-flex items-center px-4 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-md shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          @click="isModalOpen = true"
        >
          <svg
            class="-ml-0.5 mr-2 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
              clip-rule="evenodd"
            />
          </svg>
          Tambah
        </button>
      </div>
    </div>
    <Container>
      <div class="col-span-1 p-4 lg:col-span-2">
        <!-- Search Input -->
        <div class="relative mb-4 text-sm text-gray-800">
          <div
            class="absolute top-0 bottom-0 left-0 flex items-center pl-2 text-gray-500 pointer-events-none"
          >
            <MagnifyingGlassVue />
          </div>
          <input
            v-model="search"
            type="text"
            autocomplete="off"
            placeholder="Cari Nama..."
            id="search"
            class="block w-full py-2 pl-10 text-gray-900 border-0 rounded-lg ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
          <table class="min-w-full table-auto">
            <thead class="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                >
                  ID
                </th>
                <th
                  scope="col"
                  class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                >
                  Nama Dokumen
                </th>

                <th
                  scope="col"
                  class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Jenis Dokumen
                </th>
                <th
                  scope="col"
                  class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Kategori Data
                </th>
                <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                  <!-- Empty for Action Buttons -->
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <!-- Table Rows -->
              <tr v-for="(repo, index) in repositories.data" :key="repo.id">
                <td class="px-3 py-4 text-gray-500 whitespace-nowrap">
                  {{ index + 1 }}.
                </td>
                <td class="px-3 py-4 text-gray-500 whitespace-nowrap">
                  {{ repo.nama_dok }}
                </td>

                <td class="px-3 py-4 text-gray-500 whitespace-nowrap">
                  {{ repo.jenisdokumen.nama }}
                </td>
                <td class="px-3 py-4 text-gray-500 whitespace-nowrap">
                  {{ repo.publish }}
                </td>

                <td class="flex items-center justify-center py-4 space-x-2">
                  <Link
                    :href="route('pelaporan.show', repo.iddok)"
                    class="px-2 py-1 text-xs font-medium text-gray-800 bg-white border border-gray-400 rounded shadow hover:bg-gray-100"
                  >
                    <i class="fa-solid fa-file-pen"></i>
                    FILE
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ModalAddDokumen
          v-model:isOpen="isModalOpen"
          :title="form.id ? 'Edit Dokumen' : 'Tambah Dokumen'"
          :jenis="props.jenisdoks"
          :repository="form.id ? props.repositories : null"
        />

        <!-- Pagination -->
        <div class="flex justify-center mt-4">
          <Pagination
            :data="repositories"
            :updatedPageNumber="updatedPageNumber"
          />
        </div>
      </div>
    </Container>
  </div>
</template>

<script setup>
import { useForm, usePage, router } from "@inertiajs/vue3";
import { ref, computed, watch, inject } from "vue";

import Pagination from "@/Components/Pagination.vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import ModalAddDokumen from "@/Components/Pelaporan/ModalAddDokumen.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Swal from "sweetalert2";
const route = inject('route');

const isModalOpen = ref(false);
const selectedJenis = ref(false);
const props = defineProps({
  repositories: {
    type: Object,
    required: true,
  },
  jenisdoks: {
    type: Object,
    required: true,
  },
});

/**
 * @param pagination
 */

let search = ref(usePage().props.search || ""),
  pageNumber = ref(1);

let studentUrl = computed(() => {
  let url = new URL(route("pelaporan.index"));
  url.searchParams.set("page", pageNumber.value); // Use 'set' to replace existing params
  if (search.value) {
    url.searchParams.set("search", search.value); // Use 'set' for search
  }

  return url;
});

const updatedPageNumber = (link) => {
  const params = new URLSearchParams(link.url.split("?")[1]);
  pageNumber.value = params.get("page");
};

watch(
  () => studentUrl.value,
  (updatedStudentUrl) => {
    router.visit(updatedStudentUrl.toString(), {
      preserveScroll: true,
      preserveState: true,
      replace: true,
    });
  }
);

watch(
  () => search.value,
  (value) => {
    if (value) {
      pageNumber.value = 1; // Reset to page 1 when search is updated
    }
  }
);
const form = useForm({
  id: null,
});
</script>
